import { render, staticRenderFns } from "./OnlineCollaboratorsList.vue?vue&type=template&id=4c2678b6&scoped=true"
import script from "./OnlineCollaboratorsList.vue?vue&type=script&lang=js"
export * from "./OnlineCollaboratorsList.vue?vue&type=script&lang=js"
import style0 from "./OnlineCollaboratorsList.vue?vue&type=style&index=0&id=4c2678b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2678b6",
  null
  
)

export default component.exports